import { useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function EnquiryForm({ tourSlug = "", presetDestination = "", compact = false }) {
  const [form, setForm] = useState({
    name: "", phone: "", email: "", destination: presetDestination,
    travel_date: "", pax: "", budget: "", message: "", source: "Website",
  });
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) { toast.error("Please enter your name and phone number"); return; }
    setLoading(true);
    try {
      await api.post("/enquiries", { ...form, tour_slug: tourSlug, pax: form.pax ? Number(form.pax) : 1 });
      toast.success("Thank you! Our travel experts will contact you shortly.");
      setForm({ name: "", phone: "", email: "", destination: presetDestination, travel_date: "", pax: "", budget: "", message: "", source: "Website" });
    } catch (err) {
      toast.error(apiError(err));
    } finally { setLoading(false); }
  };

  const input = "w-full rounded-2xl border border-gray-200 bg-white px-4 py-3 text-sm text-navy outline-none transition-colors focus:border-brandorange";

  return (
    <form onSubmit={submit} data-testid="enquiry-form" className="space-y-3">
      <div className="grid gap-3 sm:grid-cols-2">
        <input data-testid="enquiry-name" className={input} placeholder="Full Name *" value={form.name} onChange={set("name")} />
        <input data-testid="enquiry-phone" className={input} placeholder="Phone Number *" value={form.phone} onChange={set("phone")} />
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        <input data-testid="enquiry-email" type="email" className={input} placeholder="Email" value={form.email} onChange={set("email")} />
        <input data-testid="enquiry-destination" className={input} placeholder="Destination" value={form.destination} onChange={set("destination")} />
      </div>
      {!compact && (
        <div className="grid gap-3 sm:grid-cols-3">
          <input data-testid="enquiry-date" type="date" className={input} value={form.travel_date} onChange={set("travel_date")} />
          <input data-testid="enquiry-pax" type="number" min="1" className={input} placeholder="No. of Pax" value={form.pax} onChange={set("pax")} />
          <input data-testid="enquiry-budget" className={input} placeholder="Budget (₹)" value={form.budget} onChange={set("budget")} />
        </div>
      )}
      <textarea data-testid="enquiry-message" rows={compact ? 2 : 3} className={input} placeholder="Tell us about your dream holiday..." value={form.message} onChange={set("message")} />
      <button data-testid="enquiry-submit" disabled={loading} className="btn-gradient flex w-full items-center justify-center gap-2 rounded-full py-3.5 font-bold disabled:opacity-70">
        {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Send Enquiry"}
      </button>
    </form>
  );
}
